import React from 'react';

const Process = () => {
  const steps = [
    {
      number: '01',
      title: 'Discovery',
      description: 'We analyze your business goals, target audience, and requirements to create a strategic roadmap.',
      icon: '🔍'
    },
    {
      number: '02',
      title: 'Design',
      description: 'Our designers craft beautiful, intuitive interfaces with glassmorphic aesthetics that wow users.',
      icon: '🎨'
    },
    {
      number: '03',
      title: 'Development',
      description: 'Expert developers build scalable, performant solutions using cutting-edge technologies.',
      icon: '⚙️'
    },
    {
      number: '04',
      title: 'Testing',
      description: 'Rigorous QA testing ensures reliability, security, and exceptional performance across all devices.',
      icon: '✅'
    },
    {
      number: '05',
      title: 'Launch',
      description: 'We deploy your project with precision, ensuring smooth performance and zero downtime.',
      icon: '🚀'
    },
    {
      number: '06',
      title: 'Support',
      description: 'Continuous monitoring and 24/7 support keep your solution running flawlessly.',
      icon: '💬'
    }
  ];

  return (
    <section id="process">
      <div className="section-header">
        <h2 className="section-title">Our Process</h2>
        <p className="section-subtitle">A proven 6-step methodology for project success</p>
      </div>
      <div className="process-timeline">
        {steps.map((step, index) => (
          <div className="process-step fade-in" key={index} style={{animationDelay: `${index * 0.1}s`}}>
            <div className="step-connector" style={{animationDelay: `${index * 0.1 + 0.2}s`}}></div>
            <div className="step-content">
              <div className="step-icon">{step.icon}</div>
              <div className="step-number">{step.number}</div>
              <h4>{step.title}</h4>
              <p>{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Process;
